// extracted by mini-css-extract-plugin
module.exports = {"NewsPage_byline":"NewsPage_NewsPage_byline__1PdC2","NewsPage_wrapper":"NewsPage_NewsPage_wrapper__1wMGV"};